import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
export function Impressum() {
  return <div className="min-h-screen bg-[#f4f2ee] font-sans text-[#1a1a1a] text-[14px]" data-id="element-310">
      <SiteHeader data-id="element-311" />

      <div className="max-w-[900px] mx-auto px-[20px] py-[40px]" data-id="element-312">
        <h1 className="text-[28px] font-bold text-[#1a1a1a] mb-[32px] border-b-[2px] border-[#c8c0b0] pb-[16px]" data-id="element-313">
          Impressum
        </h1>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-314">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-315">
            Angaben gemäß § 5 TMG
          </h2>

          <div className="space-y-[12px] text-[14px] leading-[1.7]" data-id="element-316">
            <p className="font-semibold text-[15px]" data-id="element-317">
              Emerald Health Solutions Ltd.
            </p>
            <p data-id="element-318">
              Unit 12, Business Centre, Sandyford
              <br data-id="element-319" />
              Dublin 18, D18 X2P9
              <br data-id="element-320" />
              Irland
            </p>
          </div>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-321">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-322">
            Vertreten durch
          </h2>
          <p className="text-[14px] leading-[1.7]" data-id="element-323">
            Geschäftsführer: Liam O'Connor
          </p>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-324">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-325">
            Kontakt
          </h2>
          <div className="space-y-[8px] text-[14px] leading-[1.7]" data-id="element-326">
            <p data-id="element-327">
              <span className="font-medium" data-id="element-328">Telefon:</span> +353 1 496 0123
            </p>
            <p data-id="element-329">
              <span className="font-medium" data-id="element-330">E-Mail:</span>{' '}
              <a href="mailto:contact@emerald-health.ie" className="text-[#1a2e4a] hover:underline" data-id="element-331">
                contact@emerald-health.ie
              </a>
            </p>
          </div>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-332">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-333">
            Registereintrag
          </h2>
          <div className="space-y-[8px] text-[14px] leading-[1.7]" data-id="element-334">
            <p data-id="element-335">
              <span className="font-medium" data-id="element-336">Handelsregisternummer:</span> 742185
            </p>
            <p data-id="element-337">
              <span className="font-medium" data-id="element-338">
                Umsatzsteuer-Identifikationsnummer:
              </span>{' '}
              IE9988776W
            </p>
          </div>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px] mb-[24px]" data-id="element-339">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-340">
            Haftungsausschluss
          </h2>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-341">
            Haftung für Inhalte
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-342">
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für
            die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können
            wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir
            gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
            als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
            gespeicherte fremde Informationen zu überwachen oder nach Umständen
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-343">
            Haftung für Links
          </h3>
          <p className="text-[14px] leading-[1.7] mb-[16px]" data-id="element-344">
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>

          <h3 className="text-[15px] font-semibold text-[#1a1a1a] mb-[12px] mt-[20px]" data-id="element-345">
            Urheberrecht
          </h3>
          <p className="text-[14px] leading-[1.7]" data-id="element-346">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>

        <div className="bg-[#fff9e6] border border-[#e8c84a] rounded-[6px] p-[20px]" data-id="element-347">
          <p className="text-[12px] text-[#666] leading-[1.6]" data-id="element-348">
            <strong data-id="element-349">Hinweis:</strong> Die Inhalte dieses Forums dienen
            ausschließlich der allgemeinen Information und ersetzen keine
            medizinische Beratung. Konsultieren Sie bei gesundheitlichen Fragen
            oder Beschwerden immer einen qualifizierten Arzt.
          </p>
        </div>
      </div>

      <SiteFooter data-id="element-350" />
    </div>;
}